export default __webpack_public_path__ + "static/media/banner-about-halu-gamashi.11e519c3.png";